import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../site/Motion";
import { DIVISIONS } from "../../lib/api";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7"];

export const DivisionsBento = ({ counts = {} }) => (
  <section className="py-24 md:py-32" data-testid="divisions-bento">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
        <Reveal>
          <p className="eyebrow">Our Divisions</p>
          <h2 className="font-display text-5xl md:text-6xl text-slate-50 mt-5 leading-[1]">Four divisions.<br /><em className="text-gold">One standard.</em></h2>
        </Reveal>
        <Reveal delay={0.1} className="max-w-md text-slate-300 leading-relaxed">
          Selby Asset Group is an asset sourcing and brokerage company serving multiple industries. Browse what is listed today, or ask us to search for exactly what you need.
        </Reveal>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:auto-rows-[340px]">
        {DIVISIONS.map((d, i) => {
          const n = counts?.[d.key] ?? 0;
          return (
            <Reveal key={d.key} delay={i * 0.08} className={`${SPANS[i]} h-[320px] lg:h-full`}>
              <Link to={`/divisions/${d.key}`} className="group relative block h-full overflow-hidden border hairline" data-testid={`division-card-${d.key}`}>
                <img src={d.img} alt={d.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0d14] via-[#0a0d14]/55 to-[#0a0d14]/10 transition-opacity duration-500 group-hover:opacity-90" />
                <div className="absolute top-6 left-6 right-6 flex justify-between items-start">
                  <span className="font-mono text-xs text-slate-200 tracking-[0.2em]">0{i + 1}</span>
                  <span className="font-mono text-[0.65rem] uppercase tracking-[0.16em] border border-white/25 bg-[#0a0d14]/60 backdrop-blur px-3 py-1.5 text-slate-100" data-testid={`division-count-${d.key}`}>
                    {n > 0 ? `${n} listed` : "Sourcing on request"}
                  </span>
                </div>
                <div className="absolute bottom-0 inset-x-0 p-6 md:p-8">
                  <div className="flex items-end justify-between gap-6">
                    <div>
                      <h3 className="font-display text-4xl md:text-5xl text-slate-50">{d.name}</h3>
                      <p className="text-sm text-slate-300 mt-3 max-w-md">{d.blurb}</p>
                    </div>
                    <span className="w-12 h-12 shrink-0 grid place-items-center border border-white/30 text-slate-100 transition-[background-color,color,transform] duration-500 group-hover:bg-[var(--gold)] group-hover:text-[#0a0d14] group-hover:rotate-45">
                      <ArrowUpRight className="w-5 h-5" />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
